'use client';

import { useCallback, useEffect, useRef } from 'react';

/**
 * Returns a `schedule` function that runs a callback after a delay.
 * Automatically cleans up on unmount and cancels any pending timeout
 * when a new one is scheduled.
 */
export function useTimeout() {
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  useEffect(() => {
    return () => {
      if (timerRef.current != null) clearTimeout(timerRef.current);
    };
  }, []);

  const schedule = useCallback((callback: () => void, delay: number) => {
    if (timerRef.current) clearTimeout(timerRef.current);
    timerRef.current = setTimeout(callback, delay);
  }, []);

  return schedule;
}
